import { Row, Col } from 'reactstrap';
import { PageHeader } from '../../components/PageHeader';
import { DataTable } from '../../components/DataTable';
import { KpiCard } from '../../components/KpiCard';
import { useMigrationStats } from './useMigrationStats';

/**
 * Produkt-Statistik Umzüge — Betreiber-Sicht, nur lesend. KPI-Kacheln oben,
 * darunter die Aufschlüsselung der Umzugs-Jobs nach Status und Kind.
 */
const fmt = new Intl.NumberFormat('de-DE');

export function NexusMigrationStatsPage() {
  const stats = useMigrationStats();
  const data = stats.data ?? {};
  const byStatus = data.byStatus ?? [];
  const byKind = data.byKind ?? [];

  return (
    <div>
      <PageHeader title="Umzüge" subtitle="Produkt-Statistik — Umzugs-Jobs nach Status und Kind" />

      <Row className="g-3 mb-3">
        <Col xs="6" md="4" lg="3"><KpiCard label="Jobs" value={fmt.format(data.jobs ?? 0)} /></Col>
        <Col xs="6" md="4" lg="3"><KpiCard label="Tenants" value={fmt.format(data.tenants ?? 0)} /></Col>
      </Row>

      <Row className="g-3">
        <Col xs={12} lg={6}>
          <div className="text-muted small text-uppercase mb-2">Nach Status</div>
          <DataTable
            loading={stats.isLoading}
            error={stats.error}
            empty={!stats.isLoading && byStatus.length === 0}
            emptyMessage="Keine Status-Daten."
            onRetry={() => stats.refetch()}
          >
            <thead>
              <tr>
                <th>Status</th>
                <th className="text-end">Jobs</th>
              </tr>
            </thead>
            <tbody>
              {byStatus.map((r) => (
                <tr key={r.status}>
                  <td className="small">{r.status}</td>
                  <td className="text-end small">{fmt.format(r.n ?? 0)}</td>
                </tr>
              ))}
            </tbody>
          </DataTable>
        </Col>

        <Col xs={12} lg={6}>
          <div className="text-muted small text-uppercase mb-2">Nach Kind</div>
          <DataTable
            loading={stats.isLoading}
            error={stats.error}
            empty={!stats.isLoading && byKind.length === 0}
            emptyMessage="Keine Kind-Daten."
            onRetry={() => stats.refetch()}
          >
            <thead>
              <tr>
                <th>Kind</th>
                <th className="text-end">Jobs</th>
              </tr>
            </thead>
            <tbody>
              {byKind.map((r) => (
                <tr key={r.kind}>
                  <td className="small">{r.kind}</td>
                  <td className="text-end small">{fmt.format(r.n ?? 0)}</td>
                </tr>
              ))}
            </tbody>
          </DataTable>
        </Col>
      </Row>
    </div>
  );
}
